function resizeNav() {
    var newHeight = window.innerHeight;
    $('.header-mobile-content').css('max-height', newHeight );
}

$(document).ready(function() {
    resizeNav();
 
    $(window).on('resize', function () {
        resizeNav();
    });
    
    //change header color on scroll
    // $(window).scroll(function() {
    //     var scroll = $(window).scrollTop();
    //     if (scroll >= 100) {
    //         $(".site-header").addClass('active');
    //     } else {
    //         $(".site-header").removeClass('active');
    //     }
    // })

    //dropdown function
    $('.menu-top .menu-item-has-children').each(function() {
        $(this).children('a').addClass('dropdown-link');
    });
    $('.dropdown-link').each(function() {
        let timeoutId;
        // Click event
        $(this).click(function(e) {
            e.preventDefault();
            $(".dropdown-link").not(this).removeClass('active');
            $(".dropdown-link").next().not($(this).next()).removeClass('dropdown');
            $(".dropdown-link").next().not($(this).next()).fadeOut(100);
            if ($(this).next().hasClass('dropdown')) {
                $(this).next().removeClass('dropdown');
                $(this).next().fadeOut(100);
                $(this).removeClass('active');
                clearTimeout(timeoutId); // Clear any pending timeout
            } else {
                $(this).next().addClass('dropdown');
                $(this).next().fadeIn(200);
                $(this).addClass('active');
            }
        });
        // Hover events
        $(this).on('mouseenter', function() {
            clearTimeout(timeoutId); // Clear any pending timeout
            $(".dropdown-link").not(this).removeClass('active');
            $(".dropdown-link").next().not($(this).next()).removeClass('dropdown');
            $(".dropdown-link").next().not($(this).next()).fadeOut(100);
            $(this).next().addClass('dropdown');
            $(this).next().fadeIn(200);
            $(this).addClass('active');
        });
        $(this).parent().on('mouseleave', function() {
            const $submenu = $(this).find('.sub-menu');
            const $link = $(this).find('.dropdown-link');
            timeoutId = setTimeout(function() {
                if (!$submenu.is(':hover')) { // Check if mouse is not over submenu
                    $submenu.removeClass('dropdown');
                    $submenu.fadeOut(100);
                    $link.removeClass('active');
                }
            }, 200); // 200ms delay
        });
        // Keep dropdown open if mouse enters submenu
        $(this).next('.sub-menu').on('mouseenter', function() {
            clearTimeout(timeoutId); // Cancel closing if mouse enters submenu
        });
        // Close submenu on mouseleave from submenu
        $(this).next('.sub-menu').on('mouseleave', function() {
            const $link = $(this).prev('.dropdown-link');
            timeoutId = setTimeout(function() {
                $(this).removeClass('dropdown');
                $(this).fadeOut(100);
                $link.removeClass('active');
            }.bind(this), 200); // 200ms delay
        });
    });
    // Close dropdown if click on page
    $(document).mouseup(function(e) {
        var container = $(".sub-menu, .dropdown-link");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(".dropdown-link").next().removeClass('dropdown');
            $(".dropdown-link").next().fadeOut(100);
            $(".dropdown-link").removeClass('active');
        }
    });

    $('.mobile--inner--wrapper .menu-item-has-children').each(function() {
        $(this).addClass('acc-submenu');
    });
    $('.mobile--inner--wrapper .menu-item-has-children').each(function() {
        $(this).children('a').click(function(e) {
            e.preventDefault();
            $(this).toggleClass('rotate');
            $(this).next().toggleClass('acc--menu--open');
            $(this).next().slideToggle('slow');
        });
    });

    $('.burger--menu--toggle').click(function() {
        $('.burger--menu--toggle').prop('disabled', true);

        //mobile menu animation
        if (!$('.header-mobile-content').hasClass("header--open")) {
            //burger toggle animation
            $('.burger--menu--toggle').addClass("burger--closed");
            $('body').addClass('nav--open');

            //open menu
            $('.header-mobile-content').addClass("header--open").removeClass("header--closed");
            $('html, body').css({
                overflow: 'hidden',
            });
        } else {
            //burger toggle animation
            $('.burger--menu--toggle').removeClass("burger--closed");
            $('body').removeClass('nav--open');

            //close menu
            $('.header-mobile-content').removeClass("header--open").addClass("header--closed");
            $('html, body').css({
                overflow: 'visible',
            });
        }

        setTimeout(function() {
            // enable click after 1 second
            $('.burger--menu--toggle').prop('disabled', false);
        }, 500); // .5 second delay
    });

    //close menu if click on page
    $(document).mouseup(function(e) {
        var container = $(".header--open, .header--burger");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-mobile-content').removeClass("header--open");
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('html, body').css({
                overflow: 'visible',
            });
            $('body').removeClass('nav--open');
        }
    });

    //hide navbar on scroll
    // $(function() {
    //     var lastScrollTop = 0,
    //         delta = 5;
    //     $(window).scroll(function() {
    //         var nowScrollTop = $(this).scrollTop();
    //         var scroll = $(window).scrollTop();

    //         if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
    //             if (nowScrollTop > lastScrollTop) {
    //                 // SCROLLING DOWN
    //                 if (scroll >= 600) {
    //                     $('.site-header').removeClass('nav-down').addClass('nav-up');
    //                 }
    //             } else {
    //                 // SCROLLING UP
    //                 $('.site-header').removeClass('nav-up').addClass('nav-down');
    //             }
    //             lastScrollTop = nowScrollTop;
    //         }
    //     });
    // });

    // Collapse header banner on scroll (keep main header fixed).
    // const $siteHeader = $('.site-header.site-header-banner');
    // if ($siteHeader.length) {
    //     const toggleBannerOnScroll = () => {
    //         if ($(window).scrollTop() > 8) {
    //             $siteHeader.addClass('banner-collapsed');
    //         } else {
    //             $siteHeader.removeClass('banner-collapsed');
    //         }
    //     };

    //     toggleBannerOnScroll();
    //     $(window).on('scroll', toggleBannerOnScroll);
    // }
});